(function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof require=="function"&&require;if(!u&&a)return a(o,!0);if(i)return i(o,!0);var f=new Error("Cannot find module '"+o+"'");throw f.code="MODULE_NOT_FOUND",f}var l=n[o]={exports:{}};t[o][0].call(l.exports,function(e){var n=t[o][1][e];return s(n?n:e)},l,l.exports,e,t,n,r)}return n[o].exports}var i=typeof require=="function"&&require;for(var o=0;o<r.length;o++)s(r[o]);return s})({1:[function(require,module,exports){
/**
 *
 * @file      _common.js
 *
 * @abstract ユーザーエージェントを取得してtouchstart, touchmove, touchendに対応するイベントをブラウザごとに振り分ける
 *
 * @author    Yoshiyuki Nakagawa
 * @updated   18/09/2015
 *
 * @see       http://stackoverflow.com/questions/8348139/detect-ios-version-less-than-5-with-javascript
 *            http://qiita.com/Evolutor_web/items/655c6402aece800fd081
 *
 */

'use strict';

/**
 *
 * 共通変数の定義
 *
 */

Object.defineProperty(exports, "__esModule", {
  value: true
});
var commonVars = exports.commonVars = function () {

  // userAgentの判定
  var ua = function () {
    return {
      Touch: typeof document.ontouchstart != 'undefined',
      Pointer: window.navigator.pointerEnabled,
      MSPoniter: window.navigator.msPointerEnabled
    };
  }();

  // イベント名の割り当て
  var start = ua.Pointer ? 'pointerdown' : ua.MSPointer ? 'MSPointerDown' : ua.Touch ? 'touchstart' : 'mousedown';
  var move = ua.Pointer ? 'pointermove' : ua.MSPointer ? 'MSPointerMove' : ua.Touch ? 'touchmove' : 'mousemove';
  var end = ua.Pointer ? 'pointerup' : ua.MSPointer ? 'MSPointerUp' : ua.Touch ? 'touchend' : 'mouseup';
  var cancel = ua.Pointer ? 'pointercancel' : ua.MSPointer ? 'MSPointerOut' : ua.Touch ? 'touchcancel' : 'mouseout';

  // userAgentに応じてscrollTopさせる要素を振り分け
  var scrollElement = function () {
    var ua = window.navigator.userAgent.toLowerCase();
    // Returns 'body' for Chrome and Safari, 'html' for Firefox and IE
    return ua.indexOf('chrome') != -1 || ua.indexOf('safari') != -1 ? 'body' : 'html';
  }();

  // public APIs
  return {
    ua: ua,
    touch: {
      start: start,
      move: move,
      end: end,
      cancel: cancel
    },
    scroll: {
      elm: scrollElement
    }
  };
}();

},{}],2:[function(require,module,exports){
/**
 *
 * @file      _menu.js
 *
 * @description
 *    opacityChangeクラスをもつ要素がタップされたらtappedクラスを追加する
 *    CSSでopacityを変化させるアニメーションを登録することでタップに反応させる
 *
 * @updated   13/11/2015
 *
 */
'use strict';

var _common = require('./_common.js');

$(document).ready(function (ev) {
    $('.opacityChange').on(_common.commonVars.touch.start, function (ev) {
        var _this = this;

        $(this).addClass('tapped');
        setTimeout(function () {
            $(_this).removeClass('tapped');
        }, 250);
    });
});

},{"./_common.js":1}],3:[function(require,module,exports){
/**
 *
 * @file      form_controller.js
 *
 * @abstract  来館予約・資料請求／お問い合わせページでのform controller for AngularJS
 *
 * @updated   02/12/2015
 *
 */
'use strict';

/**
 *
 * 「送信中」のウィンドウのFOUC対策
 *
 */

document.addEventListener('DOMContentLoaded', function () {
    document.getElementById('loader').setAttribute('style', 'opacity: 0; display: none;');
    document.getElementById('form').setAttribute('style', 'opacity: 1');
    document.getElementById('progress_window').classList.remove('initial');
});

window.addEventListener('load', function () {});

/**
 *
 * form controller for AngularJS
 *
 */
var appName = 'app';
angular.module(appName, ['ngMaterial', 'ngMessages'])
//
// @see https://material.angularjs.org/latest/#/Theming/03_configuring_a_theme
//
.config(['$mdThemingProvider', function ($mdThemingProvider) {
    $mdThemingProvider.definePalette('niho', {
        '50': '#333333',
        '100': '#333333',
        '200': '#09233d',
        '300': '#dfddd8',
        '400': '#fdfaf5',
        '500': '#333333',
        '600': '#333333',
        '700': '#fdfaf5',
        '800': '#fdfaf5',
        '900': '#fdfaf5',
        'A100': '#fdfaf5',
        'A200': '#fdfaf5',
        'A400': '#fdfaf5',
        'A700': '#fdfaf5'
    }).theme('default').primaryPalette('indigo').warnPalette('pink').backgroundPalette('niho');
}]).controller('FormController', ['$scope', '$http', '$location', '$window', function ($scope, $http, $location, $window) {
    var _this = this;

    /**
     *
     * 日付初期化
     *
     */
    this.date = new Date();
    this.minDate = new Date();
    /**
     *
     * 来館時間リスト
     *
     */
    this.timeList = window.timeList || [];
    /**
     *
     * 住所自動入力
     *
     */
    this.fillAddress = function () {
        _this.address = document.form.address.value;
    };
    /**
     *
     * POST
     * $httpでエラーが返ってきたときは/error/を表示させる
     *
     */
    this.submit = function () {
        _this.showProgress = true;
        _this.reserveDate = _this.date.getFullYear() + '年' + (_this.date.getMonth() + 1) + '月' + _this.date.getDate() + '日';
        var postURL = '../mail/send.php';
        //
        // @see http://wordpress.honobono-life.info/code/angularjs%E3%81%AEhttp%E3%82%B5%E3%83%BC%E3%83%93%E3%82%B9%E3%81%AEpost%E3%81%A7%E3%83%87%E3%83%BC%E3%82%BF%E9%80%81%E4%BF%A1/
        //
        var config = {};
        $http.post(postURL, _this, config).then(function (response) {
            //             this.showProgress = false;
            window.location.href = '../thanks/';
        }, function (response) {
            //             this.showProgress = false;
            window.location.href = '../error/';
        });
    };
}]);

},{}],4:[function(require,module,exports){
'use strict';

require('../../../../../BIS_KYOTO/BIS_KYOTO/common/js/custom/_opacityChange.js');

require('../../../../../BIS_KYOTO/BIS_KYOTO/common/js/form/_form_controller_for_LP.js');

// window.testEnv=true;

window.timeList = ['10:00', '11:00', '12:00', '13:00', '14:00', '15:00', '16:00', '17:00', '18:00']; ///////////////////////////////////////////////////////////////////////////////////
//
// @file      index.js
// @brief     JavaScript file for index.html used in http://river-suite.jp/lp/maternity-wedding-2015/
// @author    Yoshiyuki Nakagawa
// @updated   04/19/2015
//
///////////////////////////////////////////////////////////////////////////////////

$(document).ready(function () {

  'use strict';

  var ids = ['top', 'happy_angel_plan', 'fifteen_happiness', 'maternity_dress', 'faq', 'application'];
  ids.forEach(function (elm, idx, arr) {
    $('#to_' + elm).on('click', function () {
      $('#' + elm).velocity('stop').velocity("scroll", { duration: 1500 });
    });
  });

  var userAgent = window.navigator.userAgent.toLowerCase();
  if (userAgent.indexOf('chrome') != -1 || userAgent.indexOf('safari') != -1) {
    // chrome
  } else if (userAgent.indexOf('msie') != -1 || userAgent.indexOf('gecko') != -1) {
      var newStyle = document.createElement('style');newStyle.type = "text/css";
      document.getElementsByTagName('head').item(0).appendChild(newStyle);
      var css = document.styleSheets.item(0);
      //追加
      var idx = document.styleSheets[0].cssRules.length;
      css.insertRule(".md-datepicker-calendar-pane.md-whiteframe-z1.md-pane-open {position: fixed;}", idx);
    }

  //====================================================================================================
  //
  // ・ユーザーエージェントを取得してtouchstart, touchmove, touchendに対応するイベントをブラウザごとに振り分ける
  // ・ユーザーエージェントごとにscrollイベントをバインドする要素を振り分ける
  // ・ユーザーエージェントを取得してモバイル・タブレットかその他かを調べる
  //
  // Reference:
  // http://stackoverflow.com/questions/8348139/detect-ios-version-less-than-5-with-javascript
  // http://qiita.com/Evolutor_web/items/655c6402aece800fd081
  //
  //====================================================================================================

  // ユーザエージェントの取得
  var _ua = function () {
    return {
      Touch: typeof document.ontouchstart != 'undefined',
      Pointer: window.navigator.pointerEnabled,
      MSPoniter: window.navigator.msPointerEnabled
    };
  }();

  // イベント名の割り当て
  var _start = _ua.Pointer ? 'pointerdown' : _ua.MSPointer ? 'MSPointerDown' : _ua.Touch ? 'touchstart' : 'mousedown';
  var _move = _ua.Pointer ? 'pointermove' : _ua.MSPointer ? 'MSPointerMove' : _ua.Touch ? 'touchmove' : 'mousemove';
  var _end = _ua.Pointer ? 'pointerup' : _ua.MSPointer ? 'MSPointerUp' : _ua.Touch ? 'touchend' : 'mouseup';
  var _cancel = _ua.Pointer ? 'pointercancel' : _ua.MSPointer ? 'MSPointerOut' : _ua.Touch ? 'touchcancel' : 'mouseout';

  // ユーザーエージェントに応じてscrollTopさせる要素を振り分け
  var scrollAnimationElement = function () {
    var _userAgent = window.navigator.userAgent.toLowerCase();
    // Returns 'body' for Chrome and Safari, 'html' for Firefox and IE
    return _userAgent.indexOf('chrome') != -1 || _userAgent.indexOf('safari') != -1 ? 'body' : 'html';
  }();

  // @return   スマホ(sp)、タブレット(tab)、その他(other)
  var getDevice = function () {
    var ua = navigator.userAgent;
    if (ua.indexOf('iPhone') > 0 || ua.indexOf('iPod') > 0 || ua.indexOf('Android') > 0 && ua.indexOf('Mobile') > 0) {
      return 'sp';
    } else if (ua.indexOf('iPad') > 0 || ua.indexOf('Android') > 0) {
      return 'tab';
    } else {
      return 'other';
    }
  }();

  // IE10, Safari 5, Chrome 5, Firefox 4 (Gecko 2.0), Opera 11.5以降でtrue, それ以外でfalseとなる（IE9以下を除外できる）
  var modern = typeof history.pushState === 'function';

  //====================================================================================================
  //
  // HTML要素の画面上（ページ上ではない）での一を取得するためのjQueryプラグイン
  //
  //====================================================================================================

  // 要素の画面上（ページ上ではない）での位置を取得する
  $.fn.extend({
    viewportOffset: function viewportOffset() {
      var $window = $(window);
      var p = this.offset();
      return {
        left: p.left - $window.scrollLeft(),
        top: p.top - $window.scrollTop()
      };
    }
  });

  // 要素の画面上（ページ上ではない）での位置を幅・高さに対するpercentageで取得する
  $.fn.extend({
    viewportOffsetPercentage: function viewportOffsetPercentage() {
      var $window = $(window);
      var p = this.offset();
      return {
        left: (p.left - $window.scrollLeft()) / $window.width() * 100,
        top: (p.top - $window.scrollTop()) / $window.height() * 100
      };
    }
  });

  //====================================================================================================
  //
  // FAQの項目をクリックするとopen/closeクラスをトグルして内容の表示／非表示を切り替える
  // 常に一つの項目だけが表示されるようにしている
  //
  //====================================================================================================

  if (modern) {

    var itemLength = $('#faq .faq li').length;

    $('#faq .faq li').each(function (index) {
      var $this = $(this);
      $this.on('click', function () {
        // どれかの項目が開いている場合の処理
        if ($this.hasClass('opened')) {
          // 開いている項目が2つ前のクリックで開かれていた場合
          if ($this.hasClass('close-keeping-opened')) {
            $this.removeClass('close-keeping-opened').addClass('open-keeping-opened');
          }
          // 開いている項目がクリックされたらすべてを閉じる
          if ($this.hasClass('opening')) {
            $this.removeClass('opening').addClass('closing');
            $('#faq .faq li').removeClass('close-keeping-opened open-keeping-opened').removeClass('opened').addClass('closed');
            // 開いている項目以外がクリックされたら、すでに開いている項目のtop値を保ちつつclosingアニメーションを行う
          } else {
              $('#faq .faq li.opening').removeClass('opening').addClass('close-keeping-opened');
              $this.addClass('opening');
            }
          // すべての項目が閉じられている場合の処理
        } else if ($this.hasClass('closed')) {
            $('#faq .faq li.closing').removeClass('closing');
            $this.addClass('opening');
            $('#faq .faq li.closed').removeClass('closed').addClass('opened');
            // 初期状態ではどのクラスもついていない
          } else {
              $this.addClass('opening');
              $('#faq .faq li').addClass('opened');
            }
      });
    });
  } else {

    $('#faq .faq li').each(function (index) {
      var $this = $(this);
      $this.on('click', function () {
        $this.toggleClass('open-faq-item');
      });
    });
  }

  //====================================================================================================
  //
  // スクロールしていくとスライドインアニメーションさせる
  //
  //====================================================================================================

  // モダンブラウザだけでアニメーションを行う
  if (modern) {

    // 一度きりのアニメーションにするために配列を用意
    // これがfalseのとき（初回）だけアニメーションを行う
    // これを入れておかないとIEでの挙動がおかしくなる（上下にバウンドする）
    var animated = [false, false, false, false, false, false, false];

    $('#top_change_kerning_01').css({ 'opacity': '0' });
    $('#top_change_kerning_02').css({ 'opacity': '0' });
    $('#happy_angel_plan_slidein_01').css({ 'opacity': '0' });
    $('#happy_angel_plan_slidein_02').css({ 'opacity': '0' });
    $('#happy_angel_plan_slidein_03').css({ 'opacity': '0' });
    $('#fifteen_happiness_circle').css({ 'opacity': '0' });
    $('#maternity_dress_header').css({ 'opacity': '0' });
    $('#maternity_dress_content').css({ 'opacity': '0' });
    $('#faq_period').css({ 'opacity': '0' });

    // 読み込み完了時にカーニングを変化させるアニメーションを起こす
    $(window).on('load', function () {
      $('#top_change_kerning_01').addClass('changeKerning-01');
      $('#top_change_kerning_02').addClass('changeKerning-02');
      // 再読み込み時にトップへ戻るようにしているが、そのときにもアニメーションを未処理に設定する
      var animated = [false, false, false, false, false, false, false];
    });

    // スクロールイベントにイベントリスナーを登録する
    $(window).on('scroll', function () {
      if ($('#happy_angel_plan_slidein_01').viewportOffsetPercentage().top < 60 && animated[0] == false) {
        $('#happy_angel_plan_slidein_01').addClass('slideIn');
        animated[0] = true;
      }
      if ($('#happy_angel_plan_slidein_02').viewportOffsetPercentage().top < 60 && animated[1] == false) {
        $('#happy_angel_plan_slidein_02').addClass('slideIn');
        animated[1] = true;
      }
      if ($('#happy_angel_plan_slidein_03').viewportOffsetPercentage().top < 60 && animated[2] == false) {
        $('#happy_angel_plan_slidein_03').addClass('slideIn');
        animated[2] = true;
      }
      if ($('#fifteen_happiness_circle').viewportOffsetPercentage().top < 60 && animated[3] == false) {
        $('#fifteen_happiness_circle').addClass('fadeInScaleIn');
        animated[3] = true;
      }
      if ($('#maternity_dress_header').viewportOffsetPercentage().top < 60 && animated[4] == false) {
        $('#maternity_dress_header').addClass('fadeIn');
        $('#maternity_dress_content').addClass('fadeIn');
        animated[4] = true;
        animated[5] = true;
      }
      if ($('#faq_period').viewportOffsetPercentage().top < 60 && animated[6] == false) {
        $('#faq_period').addClass('downwardfadeIn');
        animated[6] = true;
      }
    });
  }

  //====================================================================================================
  //
  // ページ読み込み時にトップを表示させる
  //
  //====================================================================================================

  $(window).load(function () {
    animated = [false, false, false, false, false, false, false];
    $(scrollAnimationElement).stop().animate({ scrollTop: 0 }, 1);
  });
});

},{"../../../../../BIS_KYOTO/BIS_KYOTO/common/js/custom/_opacityChange.js":2,"../../../../../BIS_KYOTO/BIS_KYOTO/common/js/form/_form_controller_for_LP.js":3}]},{},[4]);
